import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Input,
  Container,
  Segment,
  Table,
  Grid,
  Loader
} from 'semantic-ui-react'


import titleCase from 'title-case'
import moment from 'moment'

import './SchoolYears.css'
import PaginationTable from '../../components/PaginationTable/PaginationTable'
import SchoolYearsAdd from './SchoolYearsAdd'
import SchoolYearsView from './SchoolYearsView'
import SchoolYearsEdit from './SchoolYearsEdit'
import SchoolYearsDelete from './SchoolYearsDelete'
import SchoolYearsFees from './SchoolYearsFees'

const changeCase = {
    titleCase: titleCase
}

const SchoolYearsPV = (props) => {
  if (props.auth) {
    if (props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar') {
    const { activePage, itemPerPage, column, direction, data, searchKey, fields, loaded } = props;
    let currentData = data.filter(props.isSearched(searchKey));
    const indexOfLast = activePage * itemPerPage;
    const indexOfFirst = indexOfLast - itemPerPage;
    const rowLength = currentData.length;
    currentData = currentData.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(rowLength / itemPerPage);

    const schoolYearTable = currentData.map((schoolYear, key )=> {
      return (
        <Table.Row key={key} className='schoolYears-table-row'>
          <Table.Cell>{schoolYear.name}</Table.Cell>
          <Table.Cell>{schoolYear.code}</Table.Cell>
          <Table.Cell>{moment(schoolYear.startDate).format('MMM DD, YYYY')}</Table.Cell>
          <Table.Cell>{moment(schoolYear.endDate).format('MMM DD, YYYY')}</Table.Cell>
          <Table.Cell collapsing>
            <SchoolYearsView
              schoolYear={schoolYear}
            />
            <SchoolYearsEdit
              schoolYear={schoolYear}
              handleUpdate={props.handleUpdate}
            />

            <SchoolYearsDelete
              schoolYearId={schoolYear.schoolYearId}
              schoolYearName={schoolYear.name}
              handleDelete={props.handleDelete}
            />
          </Table.Cell>
        </Table.Row>
      );
    });

    let headers = fields.map((field,index) => {
      return (
        <Table.HeaderCell
          key={index}
          sorted={column === field ? direction : null}
          onClick={() => props.handleSort(field)}
          textAlign='center'
        >
          {changeCase.titleCase(field)}
        </Table.HeaderCell>
      )
    });

    return (
      <div>
        <Container>
          <Segment>
            <Grid>
              <Grid.Column floated='left' width={8}>
                <Grid.Column width={4}>
                  <Input
                    icon='search'
                    value={searchKey}
                    onChange={props.onSearchChange}
                    placeholder='Search SchoolYears'
                  />
                </Grid.Column>
              </Grid.Column>
              <Grid.Column width={8} textAlign='right'>
                <SchoolYearsFees />
                <SchoolYearsAdd
                  handleSubmit={props.handleSubmit}
                />
              </Grid.Column>
            </Grid>
            {
              loaded ?
              <div className='table-schoolYears'>
                {
                  data.length > 0 ?
                  <Table celled selectable sortable striped size='small'>
                    <Table.Header>
                      <Table.Row>
                        {headers}
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>{schoolYearTable}</Table.Body>
                      {
                        data.length > itemPerPage ?
                        <PaginationTable
                          onPageChange={props.handlePaginationChange}
                          totalPages={totalPages}
                          activePage={activePage}
                          fields={fields}
                        >

                        </PaginationTable>
                        :
                        null
                      }
                  </Table>
                  :
                  <Segment>No school year records found.</Segment>
                }
              </div>
              :
              <Loader active inline='centered' />
            }

          </Segment>
        </Container>
      </div>
    )
  } else {
    return <Segment>You are not authorized to be in this page.</Segment>
  }
  } else {
    return <Redirect to='/' />
  }

}

export default SchoolYearsPV;
